import { useEffect, useState } from 'react';
import { axiosWrapper } from './axios';
import { Role } from '../context/AuthProvider';

// Temporary feature for a single pilot cohort - will be killed or rewritten.
// Source of truth is the backend (GroupWorkCheckIn row for today) - no client-side
// caching of "already asked today", to avoid it going stale/out of sync with the DB.
// The backend finds the student's own eligible study group and roster itself, so
// this hook works from any page, not just ones that already have classroom data loaded.
const EXCLUDED_ROLES = [Role.staff, Role.teacher, Role.manager, Role.organization_user];

interface Classmate {
  pk: string;
  fullName: string;
}

function isEligibleRole(roles: Role[] | undefined): boolean {
  if (!roles) return false;
  return (
    roles.includes(Role.student) &&
    !EXCLUDED_ROLES.some((role) => roles.includes(role))
  );
}

export default function useDailyClassmatesCheck(roles: Role[] | undefined) {
  const [shouldShowModal, setShouldShowModal] = useState(false);
  const [classmates, setClassmates] = useState<Classmate[]>([]);

  useEffect(() => {
    if (!isEligibleRole(roles)) return undefined;

    let cancelled = false;
    axiosWrapper('/api/v1/records/group_work_checkin/eligibility/', 'get')
      .then(({ data }) => {
        if (cancelled) return;
        if (data.eligible && !data.alreadySubmittedToday) {
          setClassmates(data.classmates || []);
          setShouldShowModal(true);
        }
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, [roles]);

  return {
    shouldShowModal,
    classmates,
    dismiss: () => setShouldShowModal(false),
  };
}
